import { Stream } from "./stream";
import { useGetStreamsQuery } from "../../api/apiSlice";
import { AddStreamForm } from "./addStream";

export const StreamList = () => {
  const {
    data: response = { streams: [] },
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetStreamsQuery(null, {
    pollingInterval: 60000,
  });

  let content;

  if (isLoading) {
    content = (
      <tr>
        <td>Loading...</td>
      </tr>
    );
  } else if (isSuccess) {
    content = response.streams.map((m) => <Stream key={m.name} s={m} />);
  } else if (isError) {
    if ("data" in error)
      return (
       <p>An error ({error.status}) has occured.</p>
      )
  }

  return (
    <div className="row text-light pb-4">
      <hr />
      <h3 className="text-light">Streams</h3>
      <table className="table table-dark table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Video ID</th>
            <th>Last Ping</th>
            <th>Stop</th>
          </tr>
        </thead>
        <tbody>{content}</tbody>
      </table>
      <AddStreamForm activeStreams={response.streams} />
    </div>
  );
};
